import { useSession } from '@/composables/session';
import { useRouter } from 'vue-router';
import AuthService from '@/services/authService';

export function useAuth() {
    const router = useRouter();
    const authService = new AuthService();
    const { clearSession } = useSession();

    function logout() {
        authService.Logout().finally(() => {
            clearSession();
            router.push({ name: 'loginForm', query: { ...router.currentRoute.value.query } });
        });
    }

    return {
        logout
    };
}
